<template>
  <main>
    <div
      class="koc-view koc-event-replay-view"
      data-observe-resize
      data-observe-theme
    >
      <div
        v-if="state.hasAccess && state.layoutData"
      >
        <div
          v-show="state.showPlayer"
          class="koc-event-replay-section koc-event-replay-jwplayer-section"
        >
          <div class="koc-event-replay-jwplayer-wrapper">
            <div id="jwplaylist-container" />
          </div>
        </div>
        <div
          v-for="section in state.layoutData"
          :id="section.id"
          :key="section.id"
          class="koc-event-replay-section"
          :style="{backgroundColor: section.backgroundColor ? section.backgroundColor : 'inherit', color: section.textColor ? section.textColor : 'initial' }"
        >
          <div class="koc-wrapper-component kol-wrapper">
            <h1
              v-if="section.title"
              class="koc-title-sub-bar koc-title-1"
            >
              {{ section.title }}
            </h1>

            <div
              v-for="(row, index) in section.rows"
              :key="index"
              class="koc-event-replay-section-row"
            >
              <div
                v-if="section.dayColumns"
                class="koc-event-replay-section-day-column-wrapper"
              >
                <div
                  v-for="(day, index) in row"
                  :key="index"
                  :style="{flexBasis: (100 / row.length) + '%'}"
                  class="koc-event-replay-day-container"
                >
                  <event-replay-sessions-column
                    :columns="Number(day.columns)"
                    :sessions="day.sessions"
                    :title="day.title"
                    :day-columns="true"
                    @play="playVideo"
                  />
                </div>
              </div>
              <div
                v-else
                class="koc-event-replay-section-column-wrapper"
              >
                <div
                  v-for="(track, index) in row"
                  :key="index"
                  :style="{flexBasis: (100 / row.length) + '%'}"
                  class="koc-event-replay-track-container"
                >
                  <event-replay-sessions-column
                    v-if="track.track"
                    :bg-color="track.track_color"
                    :columns="Number(track.columns)"
                    :sessions="track.sessions"
                    :title="track.title"
                    @play="playVideo"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="showDownloads"
          class="koc-event-replay-downloads-container"
        >
          <div
            v-if="state.event.downloads && state.event.downloads.length"
            class="koc-wrapper-component kol-wrapper"
          >
            <h1 class="koc-event-replay-downloads-section-title">
              Don’t Miss Out On These Attendee Only Extras!
            </h1>
            <table class="koc-event-replay-downloads-section-table">
              <tbody>
                <tr>
                  <th scope="col">
                    Title
                  </th>
                  <th scope="col">
                    Instructor
                  </th>
                  <th scope="col">
                    Link
                  </th>
                </tr>
                <tr
                  v-for="(download, index) in state.event.downloads"
                  :key="index"
                >
                  <td data-label="Title">
                    {{ download.name }}
                  </td>
                  <td data-label="Instructor">
                    {{ download.instructor }}
                  </td>
                  <td>
                    <a
                      data-label="Link"
                      :href="download.url"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download<span class="sr-only">Opens in new tab</span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        v-else
        class="koc-notification koc-fixed koc-dark koc-full koc-view koc-dark-theme"
      >
        <div class="koc-login-overlay-form-container">
          <div class="koc-kol-logo-container">
            <img src="@/assets/images/kol-logo-white.png">
          </div>
          <h3
            class="koc-auth-login-notification-text"
            v-html="state.notification"
          />
          <auth-login-component
            v-if="state.showLogin"
            @login="login"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script src="./event-replay-sections.js"></script>
<style lang="scss" scoped src="./event-replay-sections.scss"></style>
